import(/* webpackMode: "eager" */ "/app/app/(main)/terms/layout.js");
